import type { MappedFilter } from '~/ducks/machine-filter-v2/types/api-post-types';
import BFFAPI from './utils/BFFAPI';

class MachineFiltersAPI extends BFFAPI {
  getSavedFilters = () => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/saved-filters`);
    return this.fetch(req);
  };

  saveNewFilter = (filters: MappedFilter[], name: string, favorite: boolean) => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}/saved-filters`, {
      name,
      favorite,
      filters,
    });
    return this.fetch(req);
  };

  editSavedFilter = (
    filterId: string,
    filter: {
      filters: MappedFilter[];
      name: string;
      favorite: boolean;
    }
  ) => {
    const req = this.fetchHelper.createPatchRequest(
      `${this.endpoint}/saved-filters/${filterId}`,
      filter
    );
    return this.fetch(req);
  };

  removeSavedFilter = (filterId: string) => {
    const req = this.fetchHelper.createDeleteRequest(`${this.endpoint}/saved-filters/${filterId}`);
    return this.fetch(req);
  };
}

export default new MachineFiltersAPI('/fleet/secure/filters');
